import { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { SVGS } from '~/assets/assetsPath';
import styles from './DefaultLayout.module.scss';
import Footer from './Footer';
import Header from './Header';
import * as SkinScreening from '~/constants/linkSkinScreening';
import { getInfoProfile } from '~/store/actions/UserAction';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import CancelModal from '~/components/FormCancel';
import config from '~/config';
import shareAPI from '~/api/Share';
import { ENV } from '~/config/enviroment';
import { Link } from 'react-router-dom';

import { navbarMobile } from '~/constants';

const cx = classNames.bind(styles);
const getScanSkinURL = (str = 'production') => {
    if (str === 'production') {
        return SkinScreening.SKIN_SCREENING_PRODUCT;
    } else if (str === 'dev') {
        return SkinScreening.SKIN_SCREENING_DEV;
    } else if (str === 'staging') {
        return SkinScreening.SKIN_SCREENING_STAG;
    }
};

function DefaultLayout({ children, tabIndex }) {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const [productId, setProductId] = useState('');
    const [offerId, setOfferId] = useState('');
    const [sharerId, setSharerId] = useState('');

    const userInfo = useSelector((state) => state?.user?.userInfo);
    const isLogin = userInfo?.id || '';
    // const isLogin = !!localStorage.getItem('token');
    // const refreshToken = localStorage.getItem('refreshToken') || '';

    const [isShowRequireLogin, setIsShowRequireLogin] = useState(false);
    const onAgreeLogin = () => {
        // localStorage.setItem('offerId', offerId);
        // localStorage.setItem('sharerId', sharerId);
        localStorage.setItem('navigateAfterLogin', `/thong-tin-nap-tien/${offerId}?sharer_id=${sharerId}`);
        navigate(config.routes.login);
        setIsShowRequireLogin(false);
    };
    const onRejectLogin = () => {
        setIsShowRequireLogin(false);
    };

    const handleAutoNavigate = async () => {
        const search = location?.search?.split('?').join('');
        const productId = new URLSearchParams(search)?.get('product');
        const offerId = new URLSearchParams(search)?.get('offer');
        const sharerId = new URLSearchParams(search)?.get('sharer_id');
        const userId = new URLSearchParams(search)?.get('user_id');

        if (productId) {
            setProductId(productId);
        }
        if (offerId) {
            setOfferId(offerId);
        }
        if (sharerId) {
            setSharerId(sharerId);
        }

        if (location.pathname === '/') {
            if (userId) {
                localStorage.setItem('user_id', userId);
                navigate(config.routes.scan);
            }
            if (productId && sharerId) {
                if (window.innerWidth > 480) {
                    navigate(`/thong-tin-san-pham/${productId}?sharer_id=${sharerId}`);
                    if (sharerId !== userInfo?.id) {
                        const body = {
                            product_id: productId,
                            sharer_id: sharerId,
                        };
                        await shareAPI.clickOnLinkAPI(body);
                    }
                } else {
                    navigate(`/dieu-huong-chia-se?product=${productId}&sharer_id=${sharerId}`);
                }
            }
            if (offerId && sharerId) {
                // if (isLogin) {
                if (window.innerWidth > 480) {
                    navigate(`/thong-tin-nap-tien/${offerId}?sharer_id=${sharerId}`);
                    if (sharerId !== userInfo?.id) {
                        const body = {
                            offer_id: offerId,
                            sharer_id: sharerId,
                        };
                        await shareAPI.clickOnLinkAPI(body);
                    }
                } else {
                    navigate(`/dieu-huong-chia-se?offer=${offerId}&sharer_id=${sharerId}`);
                }
                // } else {
                //     setIsShowRequireLogin(true);
                // }
            }
        }
    };

    const handleCheckToken = async () => {
        if (isLogin) {
            const navigateAfterLogin = localStorage.getItem('navigateAfterLogin');
            if (location?.pathname === config.routes.login && !navigateAfterLogin) {
                navigate(config.routes.home);
            }
            dispatch(getInfoProfile());
            localStorage.removeItem('navigateAfterLogin');
            // if (temp?.code === 401) {
            //     const body = {
            //         refresh_token: refreshToken,
            //     };
            //     const resRefresh = await dispatch(handleRefreshToken(body));
            //     if (resRefresh?.code === 409) {
            //         dispatch(handleLogout());
            //         navigate(config.routes.login);
            //     }
            // }
        }
    };

    const handleClickNavigate = (item, index) => {
        if (item.id === 6) {
            if (isLogin) {
                navigate(item.path);
            } else {
                navigate(config.routes.login);
            }
        } else if (item.id === 5) {
            if (isLogin) {
                navigate(item.path);
            } else {
                navigate(config.routes.login);
            }
        } else {
            navigate(item.path);
        }
    };

    useEffect(() => {
        if (
            !location.pathname.includes(config.routes.checkOut) &&
            !location.pathname.includes(config.routes.createSchedulePage) &&
            !location.pathname.includes(config.routes.doubleCheckOut) &&
            !location.pathname.includes(config.routes.doubleSchedule)
        ) {
            localStorage.removeItem('voucherSubmit');
        }
        handleAutoNavigate();
        handleCheckToken();

        //eslint-disable-next-line;
    }, [isLogin, location.pathname]);
    return (
        <div>
            <Header tabIndex={tabIndex} />
            <div className={cx('children-wrapper')}>
                {children}
                <a
                    href={isLogin ? `${getScanSkinURL(ENV)}/${userInfo?.id}` : `${getScanSkinURL(ENV)}`}
                    target="_blank"
                    rel="noreferrer"
                >
                    <span className={cx('button_scan_skin')}>
                        <img src={SVGS.IconSkinScreening} alt="" />
                    </span>
                </a>
                <a href={`tel:19009455`}>
                    <span className={cx('button_hotline')}>
                        <img src={SVGS.IconPhone} alt="" />
                        Hotline
                    </span>
                </a>
            </div>
            <div className={cx('children-wrapper')}>
                <div className={cx('navbar')}>
                    {navbarMobile.map((item, index) => {
                        return (
                            <>
                                {index === 3 ? (
                                    <a
                                        href={
                                            isLogin
                                                ? `${getScanSkinURL(ENV)}/${userInfo?.id}`
                                                : `${getScanSkinURL(ENV)}`
                                        }
                                        target="_blank"
                                        rel="noreferrer"
                                        key={index}
                                        className={cx('nav-item', {
                                            item_selected: item.path === location.pathname,
                                        })}
                                    >
                                        <img
                                            src={item.path === location.pathname ? item.icon[0] : item.icon[1]}
                                            alt=""
                                        />
                                        <p>{item.title}</p>
                                    </a>
                                ) : (
                                    <div
                                        key={index}
                                        className={cx('nav-item', {
                                            item_selected: item.path === location.pathname,
                                        })}
                                        onClick={() => {
                                            handleClickNavigate(item, index);
                                        }}
                                    >
                                        <img
                                            src={item.path === location.pathname ? item.icon[0] : item.icon[1]}
                                            alt=""
                                        />
                                        <p>{item.title}</p>
                                    </div>
                                )}
                            </>
                        );
                    })}
                </div>
            </div>

            {isShowRequireLogin && (
                <Modal
                    centered
                    visible={isShowRequireLogin}
                    onCancel={() => setIsShowRequireLogin(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <div style={{ padding: '20px 20px' }}>
                        <CancelModal
                            onAgreeCancel={onAgreeLogin}
                            onRejectCancel={onRejectLogin}
                            text="Do you want to log in to continue?"
                        />
                    </div>
                </Modal>
            )}
            <Footer />
        </div>
    );
}

export default DefaultLayout;
